import css from 'styled-jsx/css';

const styles = css.global`.progress__container{display:flex;width:100%;height:5px;margin-bottom:5px}.progress__outer{display:flex;height:100%;width:100%;border-radius:4px;overflow:hidden}.progress__inner{height:100%;min-width:3px;border-radius:4px}`;

export default styles;